import SectionHeader from "./SectionHeader";

const COLUMNS = [
  {
    icon: "ri-article-line",
    tone: "primary",
    name: "深扒复盘",
    tagline: "把一场讨论的来龙去脉摊开讲",
    points: ["争议点梳理与时间线", "多方说法并列呈现", "不预设立场慢慢聊"],
  },
  {
    icon: "ri-megaphone-line",
    tone: "secondary",
    name: "热梗速递",
    tagline: "全网热词和新梗，追得上才接得住",
    points: ["热梗出处讲解", "语境与用法指南", "一周热词清单"],
  },
  {
    icon: "ri-heart-3-line",
    tone: "accent",
    name: "饭圈观察",
    tagline: "换个视角看懂不同圈层的表达",
    points: ["应援与产粮科普", "圈内黑话翻译", "圈内圈外视角对话"],
  },
  {
    icon: "ri-shield-check-line",
    tone: "primary",
    name: "理性吃瓜",
    tagline: "热闹归热闹，判断要清醒",
    points: ["真假消息辨别", "消息溯源小技巧", "友好讨论公约"],
  },
];

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-800",
  accent: "bg-accent-100 text-accent-800",
};

export default function Columns() {
  return (
    <section id="lanmu" className="scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeader
            eyebrow="内容栏目矩阵"
            title="群里平时聊点什么"
            desc="不只是吃瓜，我们还把娱乐话题做成能慢慢读的内容，方便新朋友快速上手。"
            align="left"
          />
          <a
            href="#joinform"
            className="hidden shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 lg:inline-flex"
          >
            想看更多栏目
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {COLUMNS.map((col) => (
            <a
              key={col.name}
              href="#joinform"
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${toneMap[col.tone]}`}>
                <i className={`${col.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-900">{col.name}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{col.tagline}</p>
              <ul className="fruit-dot mt-4 space-y-2 text-sm text-foreground-600">
                {col.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
              <span className="mt-auto inline-flex items-center gap-1 pt-5 text-xs font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                进群看往期
                <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}